import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const UnderlineIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue249'}</MuiIcon>
        );
    })